import React, { useState } from "react";
import { Link } from "react-scroll";
import { scrollDuration } from "../../../config/commonConfig";
import { Tooltip } from "../../Tooltip";

const FullScreenHeader = ({ textWhite }) => {
  const [stickyHeader, setStickyHeader] = useState(false);
  const [isNavModalClose, setIsNavModalClose] = useState(true);

  const checkScrollTop = () => {
    const header = document.getElementsByClassName("primary-menu");
    if (header) {
      if (document.body.scrollTop > 1 || document.documentElement.scrollTop > 1) {
        setStickyHeader(true);
      } else {
        setStickyHeader(false);
      }
    }
  };

  if (typeof window !== "undefined") {
    window.addEventListener("scroll", checkScrollTop);
  }

  return (
    <header id="header" className="sticky-top">
      <nav
        className={
          "primary-menu navbar navbar-expand-none navbar-overlay  bg-transparent border-bottom-0 text-5 fw-600 " +
          (stickyHeader ? "sticky-on-top " : " ") +
          (textWhite ? "navbar-overlay navbar-text-light" : "navbar-overlay-dark")
        }
      >
        <div className="container">
          <Link
            className="logo"
            title="Sina Khanjani"
            smooth="easeInOutQuint"
            duration={scrollDuration}
            style={{ cursor: "pointer" }}
            to="home"
            onClick={(e) => {
              e.preventDefault();
              setIsNavModalClose(true);
            }}
          />

          <button
            className={"navbar-toggler collapsed " + (isNavModalClose ? "" : "show")}
            type="button"
            onClick={() => setIsNavModalClose(!isNavModalClose)}
          >
            <span />
            <span />
            <span />
          </button>
          <div id="header-nav" className={"collapse navbar-collapse " + (isNavModalClose ? "" : "show")}>
            <div className="d-flex flex-column h-100 align-items-center justify-content-center">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <Link className="nav-link " smooth="easeInOutQuint" duration={scrollDuration} style={{ cursor: "pointer" }} activeClass="active" spy to="home" onClick={(e) => { e.preventDefault(); setIsNavModalClose(true); }}>
                    خانه
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link " smooth="easeInOutQuint" duration={scrollDuration} style={{ cursor: "pointer" }} activeClass="active" spy to="about" onClick={(e) => { e.preventDefault(); setIsNavModalClose(true); }}>
                    درباره من
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link " smooth="easeInOutQuint" duration={scrollDuration} style={{ cursor: "pointer" }} activeClass="active" spy to="services" onClick={(e) => { e.preventDefault(); setIsNavModalClose(true); }}>
                    خدمات
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link " smooth="easeInOutQuint" duration={scrollDuration} style={{ cursor: "pointer" }} activeClass="active" spy to="resume" onClick={(e) => { e.preventDefault(); setIsNavModalClose(true); }}>
                    رزومه
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link " smooth="easeInOutQuint" duration={scrollDuration} style={{ cursor: "pointer" }} activeClass="active" spy to="portfolio" onClick={(e) => { e.preventDefault(); setIsNavModalClose(true); }}>
                    پروژه‌ها
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link " smooth="easeInOutQuint" duration={scrollDuration} style={{ cursor: "pointer" }} activeClass="active" spy to="faq" onClick={(e) => { e.preventDefault(); setIsNavModalClose(true); }}>
                    سوالات متداول
                  </Link>
                </li>
              </ul>
              <ul className="social-icons social-icons-light social-icons-lg social-icons-light d-inline-flex mt-4">
                <li className="social-icons-github">
                  <Tooltip text="GitHub" placement="top">
                    <a
                      href="https://github.com/sinakhanjani?tab=repositories"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-github" />
                    </a>
                  </Tooltip>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default FullScreenHeader;
